/** Read currently selected MetaMask account without prompting. */
export const getMetaMaskAccounts = async () => {
  if (!window.ethereum) return [];
  const accounts = await window.ethereum.request({ method: 'eth_accounts' });
  return Array.isArray(accounts) ? accounts : [];
};

/** Prompt MetaMask to connect and return the active account (lowercased). */
export const connectMetaMaskWallet = async () => {
  if (!window.ethereum) {
    const error = new Error('MetaMask is not installed.');
    error.code = 'METAMASK_MISSING';
    throw error;
  }

  const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
  const address = accounts?.[0] ? String(accounts[0]).trim().toLowerCase() : '';
  if (!address || !/^0x[0-9a-f]{40}$/.test(address)) {
    const error = new Error('No MetaMask account selected.');
    error.code = 'METAMASK_NO_ACCOUNT';
    throw error;
  }
  return address;
};

export const formatWalletAddress = (wallet) => {
  if (!wallet) return 'Not connected';
  return String(wallet).trim();
};
